import SEOArticleLayout from "@/components/feature/SEOArticleLayout";

const IMAGE = "https://readdy.ai/api/search-image?query=Floating%20digital%20interface%20elements%20like%20charts%20and%20data%20cards%20arranged%20on%20clean%20cream%20background%2C%20modern%20UI%20design%20concept%2C%20soft%20warm%20lighting%2C%20minimal%20tech%20aesthetic%2C%20geometric%20clean%20composition%2C%20editorial%20style&width=900&height=1100&seq=seo-article-fonctionnalites-v3&orientation=portrait";

export default function FonctionnalitesPage() {
  return (
    <SEOArticleLayout
      title="Fonctionnalités du Hipobuy Spreadsheet"
      subtitle="Explorez toutes les fonctionnalités du hipobuy spreadsheet : suivi produit, analyse prix, automatisation, reporting et bien plus encore."
      heroImageUrl={IMAGE}
      heroImageAlt="Fonctionnalités Hipobuy Spreadsheet"
    >
      <section className="mb-10">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">Les fonctionnalités phares</h2>
        <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
          Le <strong>hipobuy spreadsheet</strong> propose un ensemble complet de fonctionnalités pensées pour les vendeurs e-commerce. Voici les plus importantes.
        </p>

        <div className="space-y-4">
          {[
            { icon: "ri-line-chart-line", title: "Suivi des performances en temps réel", desc: "Visualisez instantanément les ventes, les stocks et les tendances de chaque produit. Le hipobuy spreadsheet met à jour les données automatiquement." },
            { icon: "ri-scales-3-line", title: "Analyse comparative des prix", desc: "Comparez vos prix avec ceux de vos concurrents. Le hipobuy spreadsheet détecte les écarts et vous recommande des ajustements." },
            { icon: "ri-robot-3-line", title: "Automatisation intelligente", desc: "Plus besoin de saisie manuelle. Le hipobuy spreadsheet automatise la collecte, le tri et l'analyse des données produits." },
            { icon: "ri-pie-chart-2-line", title: "Reporting visuel", desc: "Des graphiques clairs et des tableaux de bord personnalisables pour suivre vos KPIs e-commerce en un coup d'œil." },
            { icon: "ri-notification-3-line", title: "Alertes intelligentes", desc: "Recevez des notifications quand un concurrent change ses prix, quand un stock est bas ou quand une opportunité se présente." },
            { icon: "ri-global-line", title: "Compatibilité multi-plateforme", desc: "Shopify, Amazon, dropshipping... Le hipobuy spreadsheet centralise toutes vos données, quelle que soit votre plateforme." },
          ].map((feat, i) => (
            <div key={i} className="flex gap-3 p-4 bg-background-100 rounded-2xl">
              <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                <i className={`${feat.icon} text-primary-600 text-lg`}></i>
              </div>
              <div>
                <h4 className="font-heading text-base font-semibold text-foreground-950 mb-1">{feat.title}</h4>
                <p className="text-xs text-foreground-500 leading-relaxed">{feat.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="mb-10">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">Des fonctionnalités pensées pour tous les vendeurs</h2>
        <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-3">
          Que vous soyez un petit vendeur qui débute ou un entrepreneur e-commerce chevronné, les fonctionnalités du <strong>hipobuy spreadsheet</strong> s'adaptent à votre niveau. L'interface est intuitive, mais la puissance d'analyse est professionnelle.
        </p>
      </section>

      <div className="mt-8 p-6 bg-accent-50 rounded-2xl border border-accent-100 text-center">
        <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2">Découvrez toutes les fonctionnalités</h3>
        <p className="text-sm text-foreground-500 mb-4">Explorez par vous-même ce que le hipobuy spreadsheet peut faire pour votre business.</p>
        <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 text-background-50 rounded-full text-sm font-semibold uppercase tracking-wider whitespace-nowrap hover:bg-accent-600 transition-colors cursor-pointer">
          Accéder à la Plateforme
          <i className="ri-arrow-right-line"></i>
        </a>
      </div>
    </SEOArticleLayout>
  );
}